import { IconButtonProps } from '@mui/material';
import Button from '../button/Button';
export default function IconButton({children, size, color = 'secondary', edge, ...props}: IconButtonProps) {
    return <Button {...props} color={color === 'default' ? 'secondary' : color} variant="text" size="small" className={`spark-icon-button ${props.className || ''}`}>{children}</Button>;
}
